package com.example.readingnotes.platform

import kotlinx.browser.window

public actual object SocialShare {
    public actual suspend fun shareContent(
        title: String,
        text: String,
        url: String,
    ): Boolean =
        try {
            val shareData =
                kotlin.js.json(
                    "title" to title,
                    "text" to text,
                    "url" to url,
                )
            window.navigator
                .asDynamic()
                .share(shareData)
            true
        } catch (e: Throwable) {
            console.error("Share failed:", e)
            false
        }

    public actual suspend fun copyToClipboard(text: String): Boolean =
        try {
            window.navigator
                .asDynamic()
                .clipboard
                .asDynamic()
                .writeText(text)
            true
        } catch (e: Throwable) {
            console.error("Copy to clipboard failed:", e)
            false
        }
}
